import React, {useEffect, useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction, toJS } from "mobx";
import PropTypes from "prop-types";
import {ComponentContext} from "../../contexts";

function TableSelector(props) {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  const compContext = useContext(ComponentContext);
  
  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);

  console.log('compContext.curView()',toJS(compContext.curView()));

  return (
    <div>
      <div className={`up12 splice s-size-${compContext.curView().add_tables.length+2}`}>
        <div className={`cell padd15 tac pointer ${compContext.cur_table_view.type === "main"?"bg-pc1-op80":""}`} onClick={()=>{
          runInAction(()=>{
            compContext.cur_table_view={"type":"main"};
          });
        }}>
          Главная таблица
        </div>
        {compContext.curView().add_tables.map((val, ind)=>{
          return (
            <div className={`cell padd15 tac pointer ${(compContext.cur_table_view.type === "add" && parseInt(ind) === compContext.cur_table_view.index)?"bg-pc1-op80":""}`} key={ind} onClick={()=>{
              runInAction(()=>{
                compContext.cur_table_view={"type":"add", "index":ind};
              });
            }}>
              Дополнительная таблица {ind+1}
            </div>
          )
        })}
        <div className={`cell padd15 tac pointer tac ${compContext.cur_table_view.type === "multi"?"bg-pc1-op80":""}`} onClick={()=>{
          console.log("click!");
            runInAction(()=>{
              compContext.cur_table_view={"type":"multi"};
            });
          }}>
          Множественные свойства
        </div>
      </div>
    </div>
  )
};

TableSelector.defaultProps = {};

TableSelector.propTypes = {}

export default observer(TableSelector);
